import { sellerConstants } from '../../_constants/seller.constants';

const initialState = { deleteSellerLoading: true, data: '', error: false, errorText: '' };

export function deleteSeller(state = initialState, action) {
    switch (action.type) {
        case sellerConstants.REQUEST_DELETE_SELLER:
            return {
                deleteSellerLoading: true,
                data: '',
                error: false,
                errorText: ''
            };
        case sellerConstants.RECEIVE_DELETE_SELLER:
        
            return {
                deleteSellerLoading: false,
                data: action.data,
                error: false,
                errorText: ''
            };
        case sellerConstants.DELETE_SELLER_ERROR:
            return {
                deleteSellerLoading: false,
                data: '',
                error: true,
                errorText: action.error
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/deleteSeller.reducer.js